import { type FC } from 'react'

import { ErrorBoundary } from '@/components/shared/error-boundary'
import { useSession } from '@/hooks/useSession'

import { PostAdCTA } from '../PostAdCTA'
import { LoggedInLinks } from './logged-in-links'
import { LoggedOutLinks } from './logged-out-links'
import { SessionMenu } from './session-menu'
import { ToolsContainer } from './styled'

type ToolsProps = {
  showPostAdCTA: boolean
}

export const Tools: FC<ToolsProps> = ({ showPostAdCTA }) => {
  const { optimisticIsAuthenticated } = useSession()

  return (
    <ToolsContainer data-testid="global-header-tools">
      <ErrorBoundary fingerprintId="Tools">
        {optimisticIsAuthenticated ? (
          <>
            <LoggedInLinks />
            <SessionMenu />
          </>
        ) : (
          <LoggedOutLinks />
        )}
      </ErrorBoundary>

      {showPostAdCTA && <PostAdCTA />}
    </ToolsContainer>
  )
}
